import { getApiPath } from './api-path';
import { baseUrl } from './extensions';
import { initClientApi } from './init-client-api';
/**
 * Создаёт клиенский API на основе вызова initClientApi с соответсвутющей декларацией и урлом
 * @param apiDeclaration
 * @param apiPath
 */
export function createClientApi(apiDeclaration, apiPath = '') {
    const delimeter = apiPath ? '/' : '';
    const getPath = (fromMock = false) => {
        // getApiPath() уже будет содержать дефолтное значение (логика в newclick-host-ui)
        // хранить дефолтное значение в корах не очень хорошо, потому что
        // если что - придётся апать все приложения
        const apiEndpointPath = getApiPath(fromMock);
        return `${apiEndpointPath}${delimeter}${apiPath}`;
    };
    const getServerPath = (apiGatewayPath) => `${apiGatewayPath}${delimeter}${apiPath}`;
    const apiMap = initClientApi(apiDeclaration, {
        getConfigExtenders: (extenders) => extenders.add(baseUrl(getPath())),
    });
    Object.entries(apiMap).reduce((agg, nextApi) => {
        const [apiKey, apiValue] = nextApi;
        apiValue.getPath = getPath;
        return {
            ...agg,
            [apiKey]: apiValue,
        };
    }, {});
    return { ...apiMap, getServerPath };
}
